import React from 'react'
import { injectStripe } from 'react-stripe-elements'
import usePrevious from '@jarvis.oddle/core/hooks/usePrevious'

/**
 * injectStripe provides stripe and stripeElement object to a React Component
 * under Elements tree
 */
const ElementWrapper = injectStripe(
  ({
    type,
    stripe,
    children,
    onStripeLoaded
  }: {
    type: string
    stripe?: Record<string, unknown>
    children
    onStripeLoaded: (stripe) => void
  }) => {
    const prevType = usePrevious(type)
    const prevStripe = usePrevious(stripe)

    /**
     * Send stripe object to the parent component,
     * this is done to allow developer to integrate stripe methods,
     * such as createSource, createToken, or createPaymentMethod,
     * with the checkout process from the parent component
     */
    React.useEffect(() => {
      if (type !== prevType || stripe !== prevStripe) {
        onStripeLoaded(stripe)
      }
    }, [onStripeLoaded, prevStripe, prevType, stripe, type])

    return children
  }
)

export default ElementWrapper
